








// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import LineChart from './LineChart.js'
import Vue from 'vue'
import { ChartData, ChartOptions } from 'chart.js'

export default Vue.extend({
  components: {
    LineChart,
  },
  data() {
    return {
      datacollection: null as null | ChartData,
      options: {
        title: {
          text: this.$t('topup.per-day'),
          display: true,
        },
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
          },
          point: {
            hoverRadius: 10,
            hitRadius: 10,
          },
        },
      } as ChartOptions,
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: [
          this.$t('monday'),
          this.$t('tuesday'),
          this.$t('wednesday'),
          this.$t('thursday'),
          this.$t('friday'),
          this.$t('saturday'),
        ],
        datasets: [
          {
            label: this.$t('this-promotion'),
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
            borderColor: this.$vuetify.theme.themes.light.accent,
            fill: false,
          },
          {
            label: this.$t('last-promotion'),
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
            borderColor: this.$vuetify.theme.themes.light.secondary,
            fill: false,
          },
        ],
      } as ChartData
    },
    getRandomInt() {
      return (Math.floor(Math.random() * (500 - 50 + 10)) + 50) * 30
    },
  },
})
